// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + "9fada3ba" + ".css";
};